import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Button, 
  Container, 
  TextField, 
  Typography,
  IconButton,
  Box
} from '@material-ui/core';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { patientActions } from '../../core/actions';
import { useDispatch } from 'react-redux';
import { RADIOLOGYREPORT } from '../../shared/constants';
import { useOrganization } from '../../configurations/OrganizationContext';
import Components from '..';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '90vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    position: 'relative',
    overflow: 'auto',
  },
  header: {
    marginBottom: theme.spacing(3),
    '& .MuiInputBase-root': {
      fontSize: '2.125rem',
      fontWeight: 'bold',
      lineHeight: 1.235,
      textAlign: 'center',
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontWeight: 'bold',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .Mui-focused': {
      '& .MuiInput-underline:after': {
        transform: 'scaleX(0)',
      },
    },
  },
  formatToolbar: {
    marginBottom: theme.spacing(2),
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    backgroundColor: '#fff',
    '& .active': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  editorContainer: {
    flex: 1,
    marginBottom: theme.spacing(3),
    '& .ql-toolbar': {
      display: 'none',
    },
    '& .ql-container': {
      border: 'none',
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    '& .ql-container.ql-snow': {
      border: 'none',
    },
    '& .ql-editor p': {
      marginBottom: theme.spacing(2),
    },
  },
  doctorInfoContainer: {
    marginBottom: theme.spacing(3),
    '& .ql-toolbar': {
      display: 'none',
    },
    '& .ql-container': {
      border: 'none',
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    '& .ql-container.ql-snow': {
      border: 'none',
    },
    '& .ql-editor': {
      // textAlign: 'center',
      padding: theme.spacing(1),
    },
    '& .ql-editor p': {
      marginBottom: theme.spacing(1),
    },
  },
  buttonContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
}));

const Abdominal = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isVisible] = useState(true);
  const org = useOrganization();
  const [printData, setPrintData] = useState(null);
  const quillRefs = useRef({});
  const [activeQuill, setActiveQuill] = useState(null);
  const [currentFormats, setCurrentFormats] = useState({});

  const [title, setTitle] = useState('ABDOMINAL/PELVIS SONOGRAPHY');
  const [reportContent, setReportContent] = useState(
    `<p><strong>LIVER:</strong> </p>
    <p><strong>GALL BLADER:</strong> </p>
<p><strong>C.B.D:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Is Normal</p>
    <p><strong>PANCREAS:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Normal in size and echotexture </p>
<p><strong>SPLEEN:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Normal in size and echotexture </p>
<p><strong>KIDNEY (R):</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Normal in size and echotexture.</br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;No evidence of hydronephrosis or renal calculi </p>
<p><strong>KIDNEY (L):</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Normal in size and echotexture.</br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;No evidence of hydronephrosis or renal calculi </p>
<p><strong>URINARY BLADDER:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Is well distended.Bladder mucosa is normal.</br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;No evidence of vesical calculi </p>
<p><strong>UTERUS:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Normal in size,outline and echotexture </p>
<p><strong>OVARIES:</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Both overies are normal in size and echotexture </p>
<p></p>
<p><strong>COMMENT:</strong> </p>
<p><strong>IMPRESSION :</strong></p>`
  );
  const [doctorInfo, setDoctorInfo] = useState(
    `<p><strong>${org?.isRadiology?.Doctor || ''}</strong></p>
<p><strong>${org?.isRadiology?.Qualification || ''}</strong></p>
<p><strong>${org?.isRadiology?.RegNo || ''}</strong></p>`
  );

  const modules = {
    toolbar: false,
    clipboard: {
      matchVisual: false
    }
  };

  const formats = ['bold', 'italic', 'underline', 'list', 'bullet'];

  // Convert data to HTML format for storage
  const convertToHTML = () => {
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>${title}</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      margin: 20px;
      white-space: pre-wrap;
    }
    .abdominal-report {
      max-width: 800px;
      margin: 0 auto;
    }
    h1 {
      text-align: center;
      margin-bottom: 30px;
      font-size: 2.125rem;
      font-weight: bold;
    }
    .report-content {
      font-size: 1rem;
      line-height: 1.5;
      white-space: pre-wrap;
    }
    .report-content p {
      margin-bottom: 16px;
    }
    .doctor-info {
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
      font-size: 1rem;
      line-height: 1.5;
    }
    .doctor-info p {
      margin-bottom: 8px;
    }
  </style>
</head>
<body>
  <div class="abdominal-report">
    <h1>${title}</h1>
    <div class="report-content">
${reportContent.replace(/  /g, '&nbsp;&nbsp;')}
    </div>
    <div class="doctor-info">
${doctorInfo.replace(/  /g, '&nbsp;&nbsp;')}
    </div>
  </div>
</body>
</html>`;
  };

  // Parse HTML content when loading existing data
  const parseHTMLContent = (htmlString) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      const titleElement = doc.querySelector('h1');
      const extractedTitle = titleElement ? titleElement.textContent.trim() : 'ABDOMINAL/PELVIS SONOGRAPHY';

      const contentElement = doc.querySelector('.report-content');
      const extractedContent = contentElement ? contentElement.innerHTML : '';

      const doctorElement = doc.querySelector('.doctor-info');
      const extractedDoctorInfo = doctorElement ? doctorElement.innerHTML :
        `<p><strong>${org?.isRadiology?.Doctor || ''}</strong></p>
<p><strong>${org?.isRadiology?.Qualification || ''}</strong></p>
<p><strong>${org?.isRadiology?.RegNo || ''}</strong></p>`;

      return {
        title: extractedTitle,
        reportContent: extractedContent,
        doctorInfo: extractedDoctorInfo
      };
    } catch (error) {
      console.error('Error parsing HTML content:', error);
      return null;
    }
  };




  useEffect(() => {
    console.log("Abdominal component mounted", props);
    if (props.selectedProcedure) {
      console.log("Selected Procedure:", props.selectedProcedure);
      const selectedProcedure = props.selectedProcedure;
      console.log("Selected Procedure Long Description:", selectedProcedure.longdesc);

      if (selectedProcedure.longdesc && selectedProcedure.longdesc !== "") {
        const longdesc = selectedProcedure.longdesc;
        console.log("Long Description:", longdesc);

        if (longdesc.trim().startsWith('<') && longdesc.includes('</')) {
          const parsedData = parseHTMLContent(longdesc);
          if (parsedData) {
            setTitle(parsedData.title);
            setReportContent(parsedData.reportContent);
            setDoctorInfo(parsedData.doctorInfo);
          }
        } else {
          try {
            let parsedData = JSON.parse(longdesc);
            console.log("Parsed Data:", parsedData);

            if (parsedData.title) {
              setTitle(parsedData.title);
            }

            if (parsedData.reportContent) {
              setReportContent(parsedData.reportContent);
            }

            if (parsedData.doctorInfo) {
              setDoctorInfo(parsedData.doctorInfo);
            }
          } catch (error) {
            console.error("Error parsing longdesc:", error);
          }
        }
      }
    }
  }, [props.selectedProcedure]);


useEffect(() => {
  if (!activeQuill) return;
  const quill = activeQuill.getEditor();
  
  const updateFormats = () => {
    if (!quill) return;
    const range = quill.getSelection();
    if (range) {
      setCurrentFormats(quill.getFormat(range));
    }
  };

  quill.on('selection-change', updateFormats);
  quill.on('text-change', updateFormats);

  updateFormats(); // Initial call

  // Cleanup listeners on editor or activeQuill change
  return () => {
    quill.off('selection-change', updateFormats);
    quill.off('text-change', updateFormats);
  };
}, [activeQuill]);



  // Edit existing procedure
  const editProcedure = (procedure) => {
    dispatch(
      patientActions.editProcedure(procedure, rescb => {
        console.log("Procedure edited successfully:", rescb);
        if (rescb && rescb.successMessages) {
          console.log("Procedure edited successfully:", rescb);
          props.closeModal({
            success: "ABDOMINAL/PELVIS SONOGRAPHY report updated successfully",
          });
        } else {
          console.error("Error editing procedure:", rescb);
        }
      })
    );
  };

  // Save new procedure
  const saveProcedure = (procedure) => {
    let new_procedure = {
      patientId: procedure.patientId,
      visitId: procedure.visitId,
      templateId: procedure.templateId,
      groupname: "ULTRASOUND",
      subgroup: RADIOLOGYREPORT,
      templateId: "ABDOMINAL/PELVIS SONOGRAPHY",
      longdesc: procedure.longdesc,
      notes: "Abdominal Report",
      billNumber: props.selectedProcedure.billNumber,
      markForDel: procedure.markForDel,
      billable: false,
      packageService: props.selectedProcedure?.packageService ? props.selectedProcedure.packageService : null
    };
    if (new_procedure.packageService && new_procedure.billable) {
      new_procedure.packageService.billable = false;
    }
    console.log("New Procedure to be saved:", new_procedure);

    dispatch(
      patientActions.insertToProcedure(new_procedure, rescb => {
        console.log("Procedure added successfully:", rescb);
        if (rescb && rescb.successMessages) {
          console.log("Procedure added successfully:", rescb);
        } else {
          console.error("Error adding procedure:", rescb);
        }
      })
    );
  };

  const handleSave = () => {
    const htmlData = convertToHTML();
    console.log('Abdominal data saved as HTML:', htmlData);

    let updatedProcedure = props.selectedProcedure;
    if (props.selectedProcedure && props.selectedProcedure.longdesc) {
      updatedProcedure.groupname = "ULTRASOUND";
      updatedProcedure.subgroup = RADIOLOGYREPORT;
      console.log("Updating existing procedure with new data");
      updatedProcedure.longdesc = htmlData;
      editProcedure(updatedProcedure);
      props.closeModal({
        success: updatedProcedure.templateId + " report updated successfully",
      });
    } else {
      if (updatedProcedure) {
        console.log("Creating new procedure with data");
        updatedProcedure.longdesc = htmlData;
        updatedProcedure.groupname = "ULTRASOUND";
        console.log("Updated Procedure:", updatedProcedure);
        editProcedure(updatedProcedure);
        saveProcedure(updatedProcedure);
      } else {
        let new_procedure = {
          patientId: props.patientInfo.id,
          visitId: props.patientInfo.visit.id,
          groupname: "ULTRASOUND",
          subgroup: RADIOLOGYREPORT,
          templateId: "ABDOMINAL/PELVIS SONOGRAPHY",
          longdesc: htmlData,
          notes: "Abdominal Report",
          billNumber: props.selectedProcedure.billNumber,
          markForDel: false,
          billable: false,
        };
        saveProcedure(new_procedure);
      }
    }
  };

  // Quill ref management
  const setQuillRef = (key, ref) => {
    quillRefs.current[key] = ref;
  };

  const handleFocus = (key) => {
    setActiveQuill(quillRefs.current[key]);
  };

  // Toolbar handlers - apply to active editor
  const handleFormat = (format) => {
    if (!activeQuill) return;
    
    const quill = activeQuill.getEditor();
    const range = quill.getSelection();
    
    if (range) {
      if (format === 'bold' || format === 'italic' || format === 'underline') {
        const current = quill.getFormat(range);
        quill.format(format, !current[format]);
      } else if (format === 'list-ordered') {
        quill.format('list', 'ordered');
      } else if (format === 'list-bullet') {
        quill.format('list', 'bullet');
      }
    }
  };

  const handlePrint = () => {
    try {
      const patient = props.patientInfo || props.patientData?.[0] || {};
      const person = patient.person || {};

      const procedureData = {
        patientId: patient.patientId || patient.id,
        visitId: patient.visitId,
        templateId: "ABDOMINAL/PELVIS SONOGRAPHY",
        subgroup: RADIOLOGYREPORT,
        longdesc: convertToHTML(),
        notes: "Abdominal Report",
        packageService: {
          name: "ABDOMINAL/PELVIS SONOGRAPHY",
          description: "Abdominal/ Pelvis Sonography",
        },
        procedureslist: [{
          ...props.selectedProcedure,
          longdesc: convertToHTML()
        }]
      };

      setPrintData({
        selectedPatient: {
          ...patient,
          id: patient.patientId || patient.id,
          fullName: patient.fullName || `${person.firstName || ''} ${person.lastName || ''}`.trim(),
          age: patient.age || person.age
        },
        templateId: "ABDOMINAL/PELVIS SONOGRAPHY",
        patientData: procedureData
      });
    } catch (error) {
      console.error("Print preparation error:", error);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Container maxWidth="lg" className={classes.root}>
      <TextField
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        fullWidth
        className={classes.header}
        inputProps={{
          'aria-label': 'report title',
          style: {
            fontWeight: 'bold',
            textAlign: 'center',
            cursor: 'text'
          }
        }}
        InputProps={{
          disableUnderline: true,
        }}
      />

      {/* Unified Toolbar */}
      <Box className={classes.formatToolbar}>
        <IconButton onClick={() => handleFormat('bold')} aria-label="bold" className={currentFormats.bold ? 'active' : ''} >
          <FormatBoldIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('italic')} aria-label="italic" className={currentFormats.italic ? 'active' : ''} >
          <FormatItalicIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('underline')} aria-label="underline" className={currentFormats.underline ? 'active' : ''} >
          <FormatUnderlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-ordered')} aria-label="ordered list" className={currentFormats.list === 'ordered' ? 'active' : ''} >
          <FormatListNumberedIcon />
        </IconButton>
        <IconButton onClick={() => handleFormat('list-bullet')} aria-label="bullet list"  className={currentFormats.list === 'bullet' ? 'active' : ''} >
          <FormatListBulletedIcon />
        </IconButton>
      </Box>

      {/* Report Content Editor */}
      <div className={classes.editorContainer}>
        <ReactQuill
          ref={ref => setQuillRef('reportContent', ref)}
          value={reportContent}
          onChange={setReportContent}
          modules={modules}
          formats={formats}
          theme="snow"
          onFocus={() => handleFocus('reportContent')}
        />
      </div>

      {/* Doctor Information Editor */}
      <div className={classes.doctorInfoContainer}>
        <ReactQuill
          ref={ref => setQuillRef('doctorInfo', ref)}
          value={doctorInfo}
          onChange={setDoctorInfo}
          modules={modules}
          formats={formats}
          theme="snow"
          onFocus={() => handleFocus('doctorInfo')}
          placeholder="Enter doctor information..."
        />
      </div>

      {/* Action Buttons */}
      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          size="large"
          style={{ marginRight: '16px' }}
        >
          Save
        </Button>
      </div>

      {/* Print Component */}
      {printData && (
        <div style={{ display: 'none' }}>
          <Components.RadiologyPrint
            doctorInfo={doctorInfo}
            patientData={printData.patientData}
            templateId={printData.templateId}
            selectedPatient={printData.selectedPatient}
          />
        </div>
      )}
    </Container>
  );
};

export default Abdominal;